export default __webpack_public_path__ + "kg.a98880c0.svg";